/**
 * SEE-1779: local stand-ins for the generated `Searchable*` types that the transaction search
 * screens used to import from `API`.
 *
 * Those types are generated by `@searchable`, which SEE-1779 R2 removes. Amplify's build pushes
 * the backend before it regenerates `API.ts` and compiles the frontend, so any `src/` import of
 * them would fail the build after the backend change had already been applied. These copies keep
 * the frontend independent of them. `see1231AmplifyDropinGuard.test.ts` stops new imports.
 *
 * Every value here is sent over the wire to the CDK `searchSpxTransactions`, so it has to be the
 * exact string the generated enum held:
 *   - Sort directions are lowercase. `CDK_API.SortDirection` is NOT a substitute: it is uppercase
 *     and type-only, and CDK's `direction` is a free `String`, so `'DESC'` would be accepted
 *     silently and change the behaviour.
 *   - Only the shapes and fields the frontend actually uses are copied, with a `Local` prefix so
 *     they can't be mistaken for generated names.
 */

export const SEARCH_SORT_DIRECTION = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type SearchSortDirection = (typeof SEARCH_SORT_DIRECTION)[keyof typeof SEARCH_SORT_DIRECTION];

/** The `HighnoteTransactionEvent` fields the transaction tables sort on. */
export const TRANSACTION_SORT_FIELD = {
  eventDate: 'eventDate',
  last4: 'last4',
  email: 'email',
  merchantName: 'merchantName',
  approvedAmountValue: 'approvedAmountValue',
} as const;

export type LocalTransactionSortField = (typeof TRANSACTION_SORT_FIELD)[keyof typeof TRANSACTION_SORT_FIELD];

export type LocalIDFilterInput = {
  ne?: string | null;
  gt?: string | null;
  lt?: string | null;
  gte?: string | null;
  lte?: string | null;
  eq?: string | null;
  match?: string | null;
  matchPhrase?: string | null;
  matchPhrasePrefix?: string | null;
  multiMatch?: string | null;
  exists?: boolean | null;
  wildcard?: string | null;
  regexp?: string | null;
  range?: Array<string | null> | null;
};

export type LocalStringFilterInput = LocalIDFilterInput;

export type LocalIntFilterInput = {
  ne?: number | null;
  gt?: number | null;
  lt?: number | null;
  gte?: number | null;
  lte?: number | null;
  eq?: number | null;
  range?: Array<number | null> | null;
};

/**
 * A transaction search filter, as the frontend builds it. Covers the fields the code reads or sets
 * by name; column filters add arbitrary keys at runtime, which the old generated type didn't
 * describe either.
 */
export type LocalTransactionFilterInput = {
  paidolId?: LocalIDFilterInput | null;
  paymentCardId?: LocalIDFilterInput | null;
  eventDate?: LocalStringFilterInput | null;
  and?: Array<LocalTransactionFilterInput | null> | null;
  or?: Array<LocalTransactionFilterInput | null> | null;
  not?: LocalTransactionFilterInput | null;
};
